import React, { Component } from "react";
import "./css/app-header.css";
import menu from "../assets/menu.svg";
import account from "../assets/account.svg";
import copy from "../assets/copy.png";
import logo from "../assets/kindly-book-black.svg";

import { Redirect, withRouter, NavLink } from "react-router-dom";

//icons
import home from "../assets/home-3-fill 1.svg";
import bookings from "../assets/calender.svg";
import list from "../assets/list-settings-fill 1.svg";
import card from "../assets/card.svg";
import team from "../assets/team-fill 1.svg";
import settings from "../assets/settings-3-fill 1.svg";
import SettingsLinks from "../settings/SettingsLinks";
import modalPoint from "../assets/modalPoint.svg";
import fullLogo from "../assets/kindly-book-white.svg";
import classNames from "classnames";

//server stuff
import { api } from "../common/server";
import { connect } from "react-redux";
import API from "../common/Api";
import { Shimmer } from "react-shimmer";
import { el } from "date-fns/locale";

const mapStateToProps = (state) => ({
  userProfile: state.userProfile,
  business: state.business,
  rizevo_login_data: state.rizevo_login_data,
  token: state.token,
  headers: state.headers(),
  getOptions: state.getOptions,
});

export default withRouter(
  connect(mapStateToProps)(
    class Layout extends Component {
      state = {
        link: `https://${window.location.host}/`,
        settingsLinksModal_IsOpen: false,
        more_modal_isOpen: false,
      };
      nav_button = React.createRef();
      settingsRef = React.createRef();

      checkLoggedInState = () => {
        if (this.props.rizevo_login_data == null) {
          return (
            <>
              <Redirect
                to={{ pathname: `/login`, search: this.props.location.search }}
              ></Redirect>
            </>
          );
        }
      };
      getUserProfile = () => {
        //fetch profile data
        fetch(`${api}/profile`, this.props.getOptions())
          .then((res) => {
            if (res.status === 401) {
              this.props.dispatch({ type: "UNAUTHORIZED" });
            }
            return res.json();
          })
          .then((obj) => {
            const data = obj.data;
            if (data) {
              this.getUserBusiness();
              this.getBookingSettings();
              this.props.dispatch({ type: "GET_PROFILE", data });
              this.props.dispatch({ type: "GET_MEMBER", data: data.member });
            }
          });
      };

      //check if user has a business....
      getUserBusiness = () => {
        API.get("business", { headers: this.props.headers }).then(
          ({ data }) => {
            this.props.dispatch({
              type: "GET_BUSINESS",
              data: data.data.business,
            });
          },
          ({ response }) => {
            this.props.dispatch({ type: "GET_BUSINESS", data: false });
          }
        );
      };
      getBookingSettings = () => {
        API.get("business/booking-settings", {
          headers: this.props.headers,
        }).then(
          ({ data }) => {
            this.props.dispatch({
              type: "GET_BOOKING_SETTINGS",
              data: { ...data.data, success: true },
            });
          },
          ({ response }) => {
            if (response.status === 403) {
              this.props.dispatch({
                type: "GET_BOOKING_SETTINGS",
                data: { success: false },
              });
            }
          }
        );
      };
      getBanks = () => {
        //getBanks...
        API.get("banks", { headers: this.props.headers }).then(({ data }) => {
          let new_data = data.data.banks;
          this.props.dispatch({ type: "GET_BANKS", data: new_data });
        });
      };

      componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside); 

        this.getUserProfile();
        this.getBanks();

        this.unlisten = this.props.history.listen((location) => {
          this.getUserProfile();
          window.scrollTo(0, 0);
          //close the navigation bar on route change
          if (this.nav_button.current)
            this.nav_button.current.classList.remove("open");
        });
      }

      handleClickOutside = (e) => {
        if (
          this.settingsRef.current &&
          !this.settingsRef.current.contains(e.target)
        ) {
          this.setState({ settingsLinksModal_IsOpen: false });
        }
      };

      openSettingsModal = () => {
        this.setState({ settingsLinksModal_IsOpen: true });
      };
      closeSettingsModal = () => {
        // allow page to change before closing modal
        setTimeout(() => {
          this.setState({ settingsLinksModal_IsOpen: false });
        }, 200);
      };
      componentWillUnmount() {
        this.unlisten();
        document.removeEventListener("mousedown", this.handleClickOutside);
      }
      toggle_navBar = () => {
        this.nav_button.current.classList.toggle("open");
      };

      getOnboardingRedirectPath = () => {
        const { business, userProfile } = this.props;
        const step = userProfile?.current_step;
        const inviteCode = business?.username || "";

        switch (step) {
          case 2:
            return "/onboarding";
          case 3:
            return "/onboarding/opening_hours";
          case 4:
            return `/onboarding/service/settings/${inviteCode}`;
          case 5:
            return `/onboarding/booking/settings/${inviteCode}`;
          default:
            return "/onboarding";
        }
      };

      redirectIfNotOnboarded = () => {
        const { userProfile, location } = this.props;
        const isTeamMember = userProfile?.account_type !== "business_owner";
        const isOnboardingRoute = location.pathname.includes("onboarding");

        if (
          userProfile?.id &&
          userProfile?.onboarding_complete === false &&
          !isTeamMember
        ) {
          const targetPath = this.getOnboardingRedirectPath();

          if (location.pathname !== targetPath) {
            return <Redirect to={targetPath} />;
          }
        } else if (userProfile?.id && userProfile?.onboarding_complete === true && isOnboardingRoute) {
          return <Redirect to="/" />;
        }

        return null;
      };

      render() {
        const isOnboardingRoute =
          this.props.location.pathname.includes("onboarding");

        return (
          <div className="layout">
            {this.checkLoggedInState()}
            {this.redirectIfNotOnboarded()}

            {this.props.userProfile.id ? (
              <>
                <div className="app-header container">
                  <div className="wrapper">
                    <div className="menu-links dsk flex center">
                      {isOnboardingRoute ? (
                        <div className="flex cursor-default">
                          <img
                            className="logo"
                            width="150px"
                            src={fullLogo}
                            alt="logo"
                            loading="lazy" decoding="async"
                          />
                        </div>
                      ) : (
                        <NavLink exact to={{ pathname: "/" }} className="flex">
                          <img
                            className="logo"
                            width="150px"
                            src={fullLogo}
                              loading="lazy" decoding="async"
                              alt="logo"
                          />
                        </NavLink>
                      )}

                      {!isOnboardingRoute && (
                        <NavLink exact to={{ pathname: "/" }} className="link">
                          Home
                        </NavLink>
                      )}
                      {!isOnboardingRoute && (
                        <NavLink
                          to={{ pathname: "/bookings" }}
                          className="link"
                        >
                          Bookings
                        </NavLink>
                      )}

                      {this.props.userProfile?.account_type !==
                        "business_team_member" && !isOnboardingRoute ? (
                        <>
                          <NavLink
                            to={{ pathname: "/payments/transactions" }}
                            className="link"
                          >
                            Payments
                          </NavLink>

                          <NavLink
                            to={{ pathname: "/services/settings" }}
                            className="link"
                          >
                            Services
                          </NavLink>

                          <NavLink to={{ pathname: "/team" }} className="link">
                            Team members
                          </NavLink>
                        </>
                      ) : (
                        ""
                      )}

                      {this.props.userProfile?.account_type !==
                        "business_team_member" && !isOnboardingRoute ? (
                          <div ref={this.settingsRef}>
                            <button
                              type="button"
                              className="modal-btn"
                              onClick={() =>
                                this.setState((prev) => ({
                                  settingsLinksModal_IsOpen: !prev.settingsLinksModal_IsOpen,
                                }))
                              }
                            >
                              <NavLink
                                to={{ pathname: "/:id/settings" }}
                                className="link"
                                style={{ pointerEvents: "none" }}
                              >
                                Settings
                              </NavLink>

                              {this.state.settingsLinksModal_IsOpen && (
                                <div
                                  className="mini-modal"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <img className="tip" src={modalPoint} alt="" />
                                  <SettingsLinks
                                    onNavigate={() =>
                                      this.setState({ settingsLinksModal_IsOpen: false })
                                    }
                                  />
                                </div>
                              )}
                            </button>
                          </div>
                      ) : (
                        ""
                      )}
                    </div>

                    <button
                      className="menu mbl"
                      ref={this.nav_button}
                      onClick={this.toggle_navBar}
                    >
                      <img src={menu} alt="" />
                    </button>

                    <div className="mobile-nav-bar absolute-modal">
                      <button
                        className="bg-btn"
                        onClick={this.toggle_navBar}
                      ></button>
                      <div className="wrapper">
                        <div
                          // className="top-content"
                          className={classNames("top-content", {
                            isOnboardingRoute: isOnboardingRoute,
                          })}
                        >
                          <img
                            className="logo"
                            width={"150px"}
                            src={logo}
                            alt=""
                          />
                          <br />
                          <br />

                          {this.props.business && !isOnboardingRoute ? (
                            <button
                              className="co-pink copy-btn flex"
                              onClick={window.copiedLink}
                              data-clipboard-text={`https://kindlybook.me/${this.props.business.username}`}
                            >
                              <img src={copy} alt="" />
                              Copy booking link
                            </button>
                          ) : null}

                          <br />

                          {!isOnboardingRoute && (
                            <div className="links">
                              <NavLink to={{ pathname: "/" }} className="link">
                                <img src={home} alt="" />
                                Home
                              </NavLink>
                              <NavLink
                                to={{ pathname: "/bookings" }}
                                className="link"
                              >
                                <img src={bookings} alt="" />
                                Bookings
                              </NavLink>
                              <NavLink
                                to={{ pathname: "/payments/transactions" }}
                                className="link"
                              >
                                <img src={card} alt="" />
                                Payments
                              </NavLink>

                              {this.props.userProfile?.account_type !==
                                "business_team_member" ? (
                                <NavLink
                                  to={{ pathname: "/services/settings" }}
                                  className="link"
                                >
                                  <img src={list} alt="" />
                                  Services
                                </NavLink>
                              ) : (
                                ""
                              )}

                              {this.props.userProfile?.account_type !==
                                "business_team_member" ? (
                                <NavLink
                                  to={{ pathname: "/team" }}
                                  className="link"
                                >
                                  <img src={team} alt="" />
                                  Team members
                                </NavLink>
                              ) : (
                                ""
                              )}

                              {this.props.userProfile?.account_type !==
                                "business_team_member" ? (
                                <NavLink
                                  to={{ pathname: "/settings" }}
                                  className="link"
                                >
                                  <img src={settings} alt="" />
                                  Settings
                                </NavLink>
                              ) : (
                                ""
                              )}
                            </div>
                          )}
                        </div>

                        {!isOnboardingRoute && (
                          <div
                            className={classNames(
                              "links no-border bottom-content",
                              {
                                isOnboardingRoute: isOnboardingRoute,
                              }
                            )}
                          >
                            <MoreLinks />
                          </div>
                        )}
                      </div>
                    </div>

                    <NavLink
                      to="#"
                      // to={{ pathname: "/profile/settings" }}
                      className="user drop-down-btn"
                    >
                      <NavLink to="#" className="user-name">
                        Hello {this.props.userProfile.first_name} 🌤
                      </NavLink>
                      <img
                        src={this.props.userProfile?.profile_picture || account}
                        alt=""
                        notRounded={`${!this.props.userProfile
                          ?.profile_picture}`}
                      />

                      <div
                        className={classNames("drop-down", {
                          isOnboardingRoute: isOnboardingRoute,
                        })}
                      >
                        <div className="card">
                          {this.props.business && !isOnboardingRoute ? (
                            <button
                              type="button"
                              className="co-pink copy-btn flex"
                              onClick={window.copiedLink}
                              data-clipboard-text={`https://kindlybook.me/${this.props.business.username}`}
                            >
                              <img src={copy} alt="" />
                              Copy booking link
                            </button>
                          ) : null}

                          {!isOnboardingRoute && (
                            <NavLink to={"/profile/settings"}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M20 22H4V20C4 18.6739 4.52678 17.4021 5.46447 16.4645C6.40215 15.5268 7.67392 15 9 15H15C16.3261 15 17.5979 15.5268 18.5355 16.4645C19.4732 17.4021 20 18.6739 20 20V22ZM12 13C11.2121 13 10.4319 12.8448 9.7039 12.5433C8.97595 12.2417 8.31451 11.7998 7.75736 11.2426C7.20021 10.6855 6.75825 10.0241 6.45672 9.2961C6.15519 8.56815 6 7.78793 6 7C6 6.21207 6.15519 5.43185 6.45672 4.7039C6.75825 3.97595 7.20021 3.31451 7.75736 2.75736C8.31451 2.20021 8.97595 1.75825 9.7039 1.45672C10.4319 1.15519 11.2121 1 12 1C13.5913 1 15.1174 1.63214 16.2426 2.75736C17.3679 3.88258 18 5.4087 18 7C18 8.5913 17.3679 10.1174 16.2426 11.2426C15.1174 12.3679 13.5913 13 12 13Z"
                                  fill="#2A2B79"
                                />
                              </svg>
                              My Profile
                            </NavLink>
                          )}
                          {!isOnboardingRoute && (
                            <NavLink
                              to={{ pathname: "/profile/integration" }}
                              className="link flex center"
                            >
                              <img src={card} alt="" />
                              Integrations
                            </NavLink>
                          )}

                          <button
                            onClick={() =>
                              this.props.dispatch({ type: "LOG_OUT" })
                            }
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0)">
                                <path
                                  d="M12.4999 10.8335C12.0391 10.8335 11.6666 11.2069 11.6666 11.6668V15.0002C11.6666 15.4593 11.2932 15.8334 10.8332 15.8334H8.33319V3.33355C8.33319 2.62189 7.87986 1.98606 7.19826 1.7494L6.95153 1.66685H10.8332C11.2932 1.66685 11.6666 2.041 11.6666 2.50028V5.00026C11.6666 5.46015 12.0391 5.83353 12.4999 5.83353C12.9607 5.83353 13.3331 5.46015 13.3331 5.00026V2.50028C13.3331 1.12197 12.2115 0.000305176 10.8332 0.000305176H1.87498C1.84324 0.000305176 1.81669 0.0144957 1.78587 0.0186155C1.74574 0.0152587 1.70744 0.000305176 1.6667 0.000305176C0.74752 0.000305176 0 0.747673 0 1.66685V16.6667C0 17.3784 0.453334 18.0142 1.13494 18.2509L6.14999 19.9226C6.31997 19.9751 6.48904 20.0001 6.66665 20.0001C7.58583 20.0001 8.33319 19.2526 8.33319 18.3334V17.5001H10.8332C12.2115 17.5001 13.3331 16.3785 13.3331 15.0002V11.6668C13.3331 11.2069 12.9607 10.8335 12.4999 10.8335Z"
                                  fill="#2A2B79"
                                />
                                <path
                                  d="M19.7555 7.74431L16.4221 4.41106C16.1839 4.17272 15.8255 4.10101 15.5139 4.2301C15.2031 4.35934 14.9997 4.66344 14.9997 5.0002V7.50017H11.6664C11.2064 7.50017 10.833 7.8734 10.833 8.33345C10.833 8.7935 11.2064 9.16672 11.6664 9.16672H14.9997V11.6667C14.9997 12.0035 15.2031 12.3076 15.5139 12.4368C15.8255 12.5659 16.1839 12.4942 16.4221 12.256L19.7555 8.92258C20.0813 8.59681 20.0813 8.07008 19.7555 7.74431Z"
                                  fill="#2A2B79"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0">
                                  <rect width="20" height="20" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                            Logout
                          </button>
                        </div>
                      </div>
                    </NavLink>
                  </div>
                </div>

                <div className="container">{this.props.children}</div>
              </>
            ) : (
              <>
                <Shimmer width={window.innerWidth} height={70} />

                <Shimmer
                  width={window.innerWidth - 32}
                  height={150}
                  className="shimmerLoader"
                />

                <Shimmer
                  width={window.innerWidth - 32}
                  height={90}
                  className="shimmerLoader"
                />

                <Shimmer
                  width={window.innerWidth - 32}
                  height={80}
                  className="shimmerLoader"
                />
              </>
            )}
          </div>
        );
      }
    }
  )
);

function MoreLinks() {
  return (
    <div className="more-links">
      <a href="/faq" target="blank" className="link">
        FAQs
      </a>
      <a href="/about" target="blank" className="link">
        About
      </a>
      <a href="/privacy" target="blank" className="link">
        Privacy
      </a>
      <a href="/terms" target="blank" className="link">
        Terms
      </a>
      {/* <a href="/#suggest-business" target="blank" className="link">
        Suggest a business
      </a> */}
    </div>
  );
}
